import { createAction } from '@wix/communities-blog-client-common';

export const APP_LOADED = 'appLoaded';

export const setAppLoaded = createAction(APP_LOADED);
